import React from 'react';


const CrossIcon = () => (
  <svg
    className="cross-icon"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.04662 2.04719C4.77662 -0.682234 9.21637 -0.682234 11.9464 2.04719C14.6758 4.77662 14.6758 9.21754 11.9464 11.9469C10.5814 13.3113 8.7894 13.9933 6.99679 13.9933C5.20419 13.9933 3.41162 13.3114 2.04662 11.9469C-0.682206 9.21752 -0.682206 4.77662 2.04662 2.04719ZM9.88369 9.88427C10.1118 9.65619 10.1118 9.28752 9.88369 9.05944L7.82156 6.99677L9.88364 4.93469C10.1117 4.70662 10.1117 4.33737 9.88364 4.10987C9.65556 3.88179 9.28689 3.88179 9.05881 4.10987L6.99674 6.17194L4.93466 4.10987C4.70659 3.88179 4.33734 3.88179 4.10984 4.10987C3.88177 4.33737 3.88177 4.70662 4.10984 4.93469L6.17192 6.99677L4.11041 9.05884C3.88234 9.28634 3.88234 9.65559 4.11041 9.88366C4.22416 9.99741 4.37352 10.0546 4.52284 10.0546C4.67159 10.0546 4.82094 9.99741 4.93527 9.88366L6.99677 7.82159L9.05884 9.88427C9.17259 9.99802 9.32194 10.0552 9.47127 10.0552C9.62062 10.0552 9.76994 9.99802 9.88369 9.88427Z"
      fill=""
    />
  </svg>
);

export default CrossIcon;
